export default __webpack_public_path__ + "static/presse-fest-bad-reichenhall-1-preview-9976ba59d061ed4a78f6271a3011a4df.jpg";